import { useCallback } from 'react';
import { DeleteBankAccountRequest, DeleteSubscriberCyberDataRequest } from 'mcsclient/models';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { MonitoringDataArray } from '../identityMonitoring.types';
import { deleteCyberDataElementsAsync } from '../identityMonitoringSlice';

/**
 * Build delete request payload
 *
 * @param dataArray
 * @param index
 */
const buildDeletePayload = (dataArray: MonitoringDataArray, index: number) => {
  const cyberData: DeleteSubscriberCyberDataRequest = {};
  switch (dataArray.dataType) {
    case 'EmailAddress':
      cyberData.emailAddresses = [dataArray.deleteValues[index].email];
      break;
    case 'TelephoneNumber':
      cyberData.telephoneNumbers = [dataArray.deleteValues[index].telephone];
      break;
    case 'MedicalID':
      cyberData.medicalIDs = [dataArray.deleteValues[index]];
      break;
    case 'Iban':
      cyberData.ibans = [dataArray.deleteValues[index]];
      break;
    case 'OtherCard':
      cyberData.otherCards = [dataArray.deleteValues[index]];
      break;
    case 'CreditCard':
      cyberData.accountDetails = {
        creditCardNumbers: [dataArray.deleteValues[index]],
      };
      break;
    case 'DebitCard':
      cyberData.accountDetails = {
        debitCardNumbers: [dataArray.deleteValues[index]],
      };
      break;
    case 'Passport':
      cyberData.passportDetails = [dataArray.deleteValues[index]];
      break;
    case 'DriverLicense':
      cyberData.driverLicense = {
        // eslint-disable-next-line i18next/no-literal-string
        number: 'true',
      };
      break;
    case 'NationalId':
      cyberData.nationalIdDetails = [dataArray.deleteValues[index]];
      break;
    case 'BankAccount': {
      const deleteBankAccountRequest: DeleteBankAccountRequest = {
        accountNumber: dataArray.deleteValues[index].accountNumber,
        bankRouting: dataArray.deleteValues[index].routingNumber, // TODO: no longer need to map bankRouting -> routingNumber after #36938601 is completed
        index: dataArray.deleteValues[index].index,
      };
      cyberData.accountDetails = {
        bankAccounts: [deleteBankAccountRequest],
      };
      break;
    }
    default:
      break;
  }

  return cyberData;
};

/**
 * Helper hook for deleting monitoring item
 */
export const useDeleteMonitoringData = () => {
  const dispatch = useAppDispatch();

  const { csid } = useAppSelector((state) => state.identityMonitoring.userContext);

  return useCallback(
    (dataArray: MonitoringDataArray, index: number) =>
      dispatch(deleteCyberDataElementsAsync({ ...buildDeletePayload(dataArray, index), csid })).unwrap(),
    [csid, dispatch]
  );
};
